import React from 'react';
import { Modal } from '@app/src/common/Modal';
import {
  TitleModal,
  SubtitlePublish,
  DescriptionModal,
  ModalBody
} from './styled';

interface Props {
  showModal?: boolean;
  closeModal?: Function;
}

export const ModalPublishClosure: React.FC<Props> = ({
  showModal,
  closeModal
}) => (
  <Modal show={showModal} closeModal={closeModal}>
    <ModalBody>
      <TitleModal>¿Hasta cuándo puedo publicar mi aviso?</TitleModal>
      {/* <SubtitlePublish>Publicación Domingo</SubtitlePublish>
      <DescriptionModal>
        Clasificados El Comercio (Cierre: Viernes 6:00 p.m)<br/>
        Clasificados Trome (Cierre: jueves 6:00 p.m)
      </DescriptionModal> */}
      <SubtitlePublish>Cierre de publicación:</SubtitlePublish>
      <DescriptionModal>
        De Martes a Viernes: Se podrá ingresar el aviso hasta un día antes a la publicación a las 5 p.m
      </DescriptionModal>
      <DescriptionModal>
        Sábado: Se podrá ingresar el aviso hasta el viernes anterior a la publicación a las 11a.m
      </DescriptionModal>
    </ModalBody>
  </Modal>
)
